import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import { DEFAULT_VALUE } from '../../constants';
import type { Task } from '../../types';
import type { TaskModel } from '../task-model';

@injectable()
export class TaskModelImpl extends AbstractModel<Task> implements TaskModel {
    protected _modelData: Task = {
        ...DEFAULT_VALUE,
    };
}
